import React from 'react';
import { observer } from 'mobx-react';
import { getFileExtension } from '../../../../utils/Utils';
const ExtensionIcon = observer(({
  fileName
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: "cms-file-extension-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "icon medium document"
  }), /*#__PURE__*/React.createElement("span", {
    className: "cms-file-extension"
  }, getFileExtension(fileName)));
});
export default ExtensionIcon;